import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'result-twog-ko-pl-overview',
  templateUrl: 'result-twog-ko-pl-overview.html',
})
export class ResultTwoGKoPlOverviewPage {
  gamePlanList: IGamePlan[] = [];
  
  @Input() plan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  margin: boolean = false;

  constructor(private navCtrl: NavController, private translate: TranslateService){
    console.log(navCtrl.getViews());
  }

  onOpenEdit(r: number, i: number, j: number){
    this.onEdit.emit({ r: r, i: i, j: j, graph: false});
  }

  onRemoveTeam(){ }

  sort(){
    if(!this.plan) return [];

    return this.plan.teams.sort((a, b) => b.points - a.points);
  }

  getGroupName(i: number){
    let ASCII = 65;
    return String.fromCharCode(ASCII + i);
  }

  getRoundName(r){
    switch (r){
      case 0: return this.translate.instant('FIRST_ROUND');
      case 1: return this.translate.instant('SECOND_ROUND');
      default: return this.translate.instant('ROUND') + (r + 1);
    }
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-twog-ko-pl/overview/result-twog-ko-pl-overview.ts